import { Type } from '@angular/core';
import { LoginProvider } from './base/login-provider.interface';
import { AuthValidators } from './validators/auth.validators';
import { ValidationErrors } from '@angular/forms';
import { AuthPageProvider } from './base/auth-page-provider.interface';
import { Browser } from 'detect-browser';

export interface LoginConfigInterface {
  environment: any;
  redirectAfterLogin: string;
  defaultLanguage: string;
  productName: string;
  backgroundImageUrl?: string;
  logoImageUrl?: string;
  translations?: {
    [languageCode: string]: {
      [KEY: string]:
        | string
        | {
        [KEY: string]:
          | string
          | { [KEY: string]: string | { [KEY: string]: string | { [KEY: string]: string | { [KEY: string]: string } } } };
      };
    };
  };
  loginService?: Type<LoginProvider>;
  activationService?: Type<AuthPageProvider>;
  displayPassword?: boolean | DisplayPasswordOptions; // boolean for default options
  passwordValidator?: (control) => ValidationErrors;
  displayInputsLabel?: boolean;
  unsupportedBrowsers?: UnsupportedBrowser[];
}

export interface UnsupportedBrowser {
  browser: Browser | string;
  minimalVersion: string | number | null;
}

export interface DisplayPasswordOptions {
  hideIcon?: string;
  showIcon?: string;
  autoCloseTimeout: number;
}

export class LoginConfig implements LoginConfigInterface {
  environment = null;
  redirectAfterLogin = '/';
  defaultLanguage = 'nl';
  productName = '';
  backgroundImageUrl = '/assets/images/emendis-complete-bg.jpg';
  logoImageUrl = '/assets/images/emendis-complete-logo.png';
  translations: {};
  loginService?: Type<LoginProvider>;
  activationService?: Type<AuthPageProvider>;
  displayPassword: boolean | DisplayPasswordOptions = null;
  passwordValidator = AuthValidators.password;
  displayInputsLabel = false;
  unsupportedBrowsers = [
    {
      browser: 'ie',
      minimalVersion: null,
    },
  ];
}
